const EventEmitter = require('events');

let EventEmitterInstance = null;

export default function getEventEmitterInstance() {
    if (!EventEmitterInstance) {
        EventEmitterInstance = new EventEmitter();
    }
    return EventEmitterInstance;
}



// WEBPACK FOOTER //
// ./data/common/EventEmitter.js